/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningssortdescending2Inputs */

const en_earningssortdescending2 = /** @type {(inputs: Earningssortdescending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`descending`)
};

const de_earningssortdescending2 = /** @type {(inputs: Earningssortdescending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`absteigend`)
};

/**
* | output |
* | --- |
* | "descending" |
*
* @param {Earningssortdescending2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningssortdescending2 = /** @type {((inputs?: Earningssortdescending2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningssortdescending2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningssortdescending2(inputs)
	return de_earningssortdescending2(inputs)
});
export { earningssortdescending2 as "earningsSortDescending" }